// extracted by mini-css-extract-plugin
export default {"container":"Tip_container__XtJvl","title":"Tip_title__VwdyU","text":"Tip_text__Se1F1"};